<template lang="">
    <BreadCrumb :items="breadcrumbItems" />
    <main id="main">
        <FaqListForm/>
    </main>
</template>
<script>
import FaqListForm from '@/components/customerService/FaqListForm.vue';
import BreadCrumb from "../layout/navigation/BreadCrumb.vue";

export default {
    data() {
        return {
            breadcrumbItems: [
                { href: "/", text: "홈", isHome: true },
                { href: "#", text: "고객센터" },
            ],
        };
    },
    components: {
        FaqListForm,
        BreadCrumb
    }
}
</script>
<style lang="">
    
</style>